import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Settings, Zap, GitBranch, ChevronUp } from 'lucide-react';

const BotNode = ({ id, data, selected }) => {
  const isTrigger = data.type === 1;
  const isCondition = data.type === 3;
  
  // Identifica o tipo de nó para a classe base
  const nodeClass = isTrigger ? 'is-trigger' : isCondition ? 'is-condition' : 'is-action';

  /**
   * LÓGICA DE BORDA DINÂMICA
   * Procura o parâmetro "resultado" dentro de data.parameters
   */
  const resultadoParam = data.parameters?.find(p => p.id === 'resultado');
  const valorResultado = resultadoParam?.value;

  let borderStyle = {};
  if (valorResultado === 'true') {
    borderStyle = { border: '2px solid #22c55e', boxShadow: '0 0 10px rgba(34, 197, 94, 0.3)' };
  } else if (valorResultado === 'false') {
    borderStyle = { border: '2px solid #ef4444', boxShadow: '0 0 10px rgba(239, 68, 68, 0.3)' };
  }

  return (
    <div 
      className={`custom-node ${nodeClass} ${selected ? 'is-selected' : ''}`}
      style={{ ...borderStyle }}
    >
      {/* Entrada (Target) - Todos os nós exceto o Trigger (Início) */}
      {!isTrigger && (
        <Handle 
          type="target" 
          position={Position.Top} 
          className="handle-top-target" 
        />
      )}

      <div className="node-content">
        <div className="node-header">
          <div className="header-main-content">
            <span style={{ marginRight: '8px', display: 'flex' }}>
              {isTrigger ? <Zap size={14} color="#00FF00" /> : 
               isCondition ? <GitBranch size={14} color="#FF69B4" /> : 
               <ChevronUp size={14} color="#00FFFF" />}
            </span>
            <span className="node-label-title"> 
              {data.label}
            </span>
          </div>
          <Settings size={12} className="node-edit-icon" />
        </div>
        
        <div className="node-body-text" style={{ fontSize: '10px', marginTop: '4px', opacity: 0.7 }}>
          {data.action_id === 1 ? "💬 Mensagem" : data.description || "Passo do robô"}
          {/* Badge visual de status se houver resultado definido */}
          {valorResultado && (
            <div style={{ 
              marginTop: '5px', 
              fontSize: '8px', 
              fontWeight: 'bold',
              color: valorResultado === 'true' ? '#22c55e' : '#ef4444' 
            }}>
              STATUS: {valorResultado === 'true' ? 'SUCESSO' : 'FALHA'}
            </div>
          )}
        </div>
        <span style={{ marginRight: '8px', display: 'flex' }} >{data.identifier}</span>
      </div>

      {/* Saída Única (Source) - Todos os nós têm apenas uma saída agora */}
      <Handle 
        type="source" 
        position={Position.Bottom} 
        id="output" 
        className="handle-bottom-source" 
      />
    </div>
  );
};

export default memo(BotNode);